import { createSlice, Draft, PayloadAction, current } from '@reduxjs/toolkit';
import { formatCheckIn, formatStartTime } from '../../../../utils/formatDate';
import { createMultiOptions, createSelectOptions } from '../../../../utils/createOptions';

const initialState: any = {
	limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 10,
	page: 1,
	count: null,
	data: [],
	employeeStatusOptions: [],
	routeVisitTypeOptions: [],
	pages: 0,
	totalIncome: 0,
	totalPlaces: 0,
	totalPlannedWage: 0,
	totalReports: 0,
	totalVisits: 0,
	totalWorkload: 0,
	syncTrue: 0,
	syncFalse: 0,
	routesInputValues: {
		routeNo: null,
		merch: [],
		visitType: [],
		employeeStatus: null,
		income: {
			from: null,
			to: null
		},
		wage: {
			from: null,
			to: null
		},
	},
	vacantRoutesInputValues: {
		routeNo: null,
		merch: [],
		visitType: [],
		employeeStatus: null,
	},
	routesSettings: JSON.parse(
		localStorage.getItem('selectedRoutesTabs') as string
	) || [
			'routeNo',
			'merch',
			'visitType',
			'sync',
			'checkin',
			'checkout',
			'smena',
			'plan',
			'sdano',
			'login',
			'employeeStatus',
			'routeType',
			'vacancyName',
			'vsv',
			'supervisor',
			'tt',
			'visitsOnWeek',
			'income',
			'plannedWage',
		],
};
export const routesSlice = createSlice({
	name: 'routesNoModal',
	initialState,
	reducers: {
		reducerGetRoutes: (state: Draft<any>, action: PayloadAction<any>) => {
			state.count = action.payload.data.count;
			state.data =
				action.payload.data?.data?.sort(
					(a: any, b: any) => a.routeNo - b.routeNo
				) || [];
			state.pages = action.payload.data.pages;
			state.totalIncome = action.payload.data.totalIncome;
			state.totalPlaces = action.payload.data.totalPlaces;
			state.totalPlannedWage = action.payload.data.totalPlannedWage;
			state.totalReports = action.payload.data.totalReports;
			state.totalVisits = action.payload.data.totalVisits;
			state.totalWorkload = action.payload.data.totalWorkload;
			state.checkboxes = action.payload.data?.data?.reduce(
				(acc: any, route: any) => {
					acc[route.routeNo] = false;
					return acc;
				},
				{}
			);
			state.vacantCheckboxes = action.payload.data?.data?.reduce(
				(acc: any, route: any) => {
					acc[route.routeNo] = false;
					return acc;
				},
				{}
			);
			state.totalVisitsDiff = action.payload.data?.data?.reduce((sum: any, item: any) => sum + (item.visitsDiff || 0), 0)
			const allowedStatusTypes = [
				'Active',
				'ActiveNoVacancy',
				'Vacant',
				'VacantNoVacancy',
				'Replacement',
				'ReplacementNoVacancy',
			];
			state.vacantRoutes = action.payload.data?.data?.filter((el: any) => {
				return (
					el.routeStatusType &&
					allowedStatusTypes.some(status =>
						Object.keys(el.routeStatusType).includes(status)
					)
				);
			});
			state.syncTrue =
				action.payload?.data?.data?.filter((route: any) =>
					route.hasOwnProperty('syncTime')
				).length || 0;
			state.syncFalse =
				action.payload?.data?.data?.filter(
					(route: any) => !route.hasOwnProperty('syncTime')
				).length || 0;
			for (let i = 0; i < action.payload.data?.data?.length; i++) {
				if (
					action.payload.data.data[i].checkIn ||
					action.payload.data.data[i].startTime
				) {
				} else {
					action.payload.data.data[i].alarmSync = false;
				}
				const userCheckIn = formatCheckIn(action.payload.data.data[i].checkIn);
				const userStartTime = formatStartTime(
					action.payload.data.data[i].startTime
				);
				const diffTime = userStartTime - userCheckIn;
				if (diffTime < 30 || diffTime > 120) {
					action.payload.data.data[i].alarmSync = true;
				} else {
					action.payload.data.data[i].alarmSync = false;
				}
			}
		},
		reducerGetRoutesFilters: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.filters = action.payload.data;
			state.merchOptions = createMultiOptions(action.payload.data?.merch);
			state.vsupervisorOptions = createMultiOptions(action.payload.data?.vsupervisor);
			state.svOptions = createMultiOptions(action.payload.data?.supervisor);
			state.projectOptions = createMultiOptions(action.payload.data?.project);
			state.routeTypeOptions = action.payload.data?.routeStatusType?.map(
				(option: any) => {
					const key = Object.keys(option)[0];
					const value = option[key];
					return { value: key, label: value };
				}
			);
			state.employeeStatusOptions = createSelectOptions(action.payload.data?.employeeStatus);
		},
		reducerRoutesInputValues: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.routesInputValues = action.payload;
		},
		reducerSortRoutesList: (state: Draft<any>, action: PayloadAction<any>) => {
			const { column, direction } = action.payload

			if (direction === 'none') {
				state.data = [...state.data].sort(
					(a: any, b: any) => a.routeNo - b.routeNo
				) || [];
			}
			const getNumber = (t: any) => {
				if (t) {
					return +t.replace(/:/g, '');
				} else return 0;
			}

			if (direction === 'up') {
				state.data = [...current(state.data)].sort(
					(a: any, b: any) => {
						if (typeof a[column] === 'number') {
							return a[column] - b[column]
						} else {
							return getNumber(a[column]) - getNumber(b[column])
						}
					}
				) || [];
			}

			if (direction === 'down') {
				state.data = [...state.data].sort(
					(a: any, b: any) => {
						if (typeof a[column] === 'number') {
							return b[column] - a[column]
						} else {
							return getNumber(b[column]) - getNumber(a[column])
						}
					}
				) || [];
			}
		},
		reducerSetCBnew: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.CBnew = action.payload
		},
		reducerSelectedRoutesNew: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.selectedRoutesNew = action.payload;
		},
		reducerRoutesNoModalClearInputValues: (
			state: Draft<any>,
		) => {
			return initialState;
		}
	},
});

export const {
	reducerGetRoutes,
	reducerRoutesInputValues,
	reducerGetRoutesFilters,
	reducerSortRoutesList,
	reducerRoutesNoModalClearInputValues,
} = routesSlice.actions;

export default routesSlice.reducer;
